var loader = require('./dist/zoomModule');

module.exports = loader;